import React from "react";
import { SettlementList } from "./settlement/list";

const BlockSettlementPage = (props) => {
  return (
    <SettlementList
      location={props.location}
      defaultFilters={{ block: props.blockId }}
    />
  );
};

export default BlockSettlementPage;
